(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noble-starter-options"]) return;
  try {
    
  if (!customElements.get('noble-starter-options')) {
    customElements.define('noble-starter-options', class extends HTMLElement {
      connectedCallback() {
        this.start = () => {
          this.productInfo = document.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
          if (!this.productInfo) return;
          this.observer = new MutationObserver(() => this.syncChoices());
          this.observer.observe(this.productInfo, { childList: true, subtree: true });
          this.variantHandler = event => {
            if (event.detail?.sectionId !== this.productInfo.dataset.section) return;
            const variant = event.detail.variant;
            if (!variant?.id) return;
            this.productInfo.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(input => {
              input.value = variant.id;
              input.disabled = !variant.available;
            });
            this.syncChoices();
          };
          document.addEventListener('variant:change', this.variantHandler);
          this.syncChoices();
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, { once: true });
        else this.start();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('DOMContentLoaded', this.start);
        document.removeEventListener('variant:change', this.variantHandler);
        this.wrapper?.remove();
      }
      makeChoice(labelText, values, suffix) {
        const container = document.createElement('div');
        container.className = 'product-form__input product-form__input--dropdown';
        const label = document.createElement('label');
        label.className = 'form__label';
        label.textContent = labelText;
        const frame = document.createElement('div');
        frame.className = 'select';
        const select = document.createElement('select');
        select.className = 'select__select';
        select.id = `NobleStarter-${this.dataset.productId}-${suffix}`;
        label.htmlFor = select.id;
        values.forEach(value => select.add(new Option(value, value)));
        const icon = this.productInfo.querySelector('variant-selects .select svg');
        frame.append(select);
        if (icon) frame.append(icon.cloneNode(true));
        container.append(label, frame);
        select.addEventListener('change', event => {
          event.stopPropagation();
          const combined = this.productInfo.querySelector('variant-selects[data-primary] select[data-noble-combined]');
          if (!combined) return;
          const value = `${this.face.value} + ${this.body.value}`;
          if (!Array.from(combined.options).some(option => option.value === value)) return;
          combined.value = value;
          combined.dispatchEvent(new Event('change', { bubbles: true }));
        });
        return { container, select };
      }
      syncChoices() {
        const picker = this.productInfo.querySelector('variant-selects[data-primary]');
        const combined = picker?.querySelectorAll('select')[2];
        if (!combined || !Array.from(combined.options).every(option => option.value.includes(' + '))) return;
        combined.dataset.nobleCombined = 'true';
        const original = combined.closest('.product-form__input');
        original.classList.add('noble-starter-combined');
        original.hidden = true;
        if (!this.wrapper?.isConnected) {
          const pairs = Array.from(combined.options, option => option.value.split(' + '));
          const faces = [...new Set(pairs.map(pair => pair[0]))];
          const bodies = [...new Set(pairs.map(pair => pair[1]))];
          this.wrapper = document.createElement('div');
          this.wrapper.className = 'noble-starter-choices';
          const face = this.makeChoice(this.dataset.faceLabel, faces, 'face');
          const body = this.makeChoice(this.dataset.bodyLabel, bodies, 'body');
          this.face = face.select;
          this.body = body.select;
          this.wrapper.append(face.container, body.container);
          picker.after(this.wrapper);
        }
        const [face, body] = combined.value.split(' + ');
        this.face.value = face;
        this.body.value = body;
        if (!this.defaultApplied) {
          this.defaultApplied = true;
          const hasRequestedVariant = new URL(window.location.href).searchParams.has('variant');
          const rejuvenate = `Rejuvenate + ${body}`;
          if (!hasRequestedVariant && Array.from(combined.options).some(option => option.value === rejuvenate)) {
            this.face.value = 'Rejuvenate';
            combined.value = rejuvenate;
            combined.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
